export default function useCharacterCounter(pageSize) {
  // Determine max character count based on page size
  let maxCount

  if (pageSize === 'full') {
    maxCount = { title: 70, text: 1360, lineClamp: 25 }
  } else if (pageSize === 'half') {
    maxCount = { title: 70, text: 600, lineClamp: 11 }
  } else {
    maxCount = { title: 35, text: 240, lineClamp: 11 }
  }

  const maxTitleCount = maxCount.title
  const maxTextCount = maxCount.text
  const lineCap = maxCount.lineClamp

  return { maxTitleCount, maxTextCount, lineCap }
}
